<template>
  <SidebarGroup
    v-if="item.children"
    :item="item"
    :compact="compact"
    @toggle="emit('toggle')" />
  <li v-else>
    <AppLink
      :href="item.href"
      class="app-sidebar__item"
      :class="{ active: item.active }">
      <i
        v-if="item.icon"
        :class="item.icon" />
      <span>{{ item.label }}</span>
    </AppLink>
  </li>
</template>

<script setup>
import SidebarGroup from './SidebarGroup.vue'

defineProps({
  item: { type: Object, required: true },
  compact: { type: Boolean, default: false }
})

const emit = defineEmits(['toggle'])
</script>
